module.exports = __webpack_public_path__ + "img/international-moves.8bfd1b0.webp";